const tabs = {
    get_started: 'Commencez',
    dashboard: 'Tableau de bord',
    applications: 'Applications',
    api_resources: 'Ressources API',
    sign_in_experience: 'Expérience de connexion',
    connectors: 'Connecteurs',
    enterprise_sso: "SSO d'entreprise",
    webhooks: 'Webhooks',
    organizations: 'Organisations',
    users: 'Gestion des utilisateurs',
    audit_logs: "Journaux d'audit",
    roles: 'Rôles',
    docs: 'Documentation',
    tenant_settings: 'Paramètres du locataire',
    mfa: 'Authentification multi-facteur',
    /** UNTRANSLATED */
    customize_jwt: 'JWT Claims',
    signing_keys: 'Clés de signature',
    organization_template: "Modèle d'organisation",
};
export default Object.freeze(tabs);
